export default "__VITE_ASSET__CQcCCl61__"